import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall } from 'app/queries/types/TCall';
import type { teamsKeys } from './teamsKeys';

type TParams = QueryFunctionContext<ReturnType<typeof teamsKeys.listsByOrganization>>;

export const createFetchOrganizationTeamsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId }], signal }: TParams) =>
    call(() => cancelOnSignal(OrganizationsService.getOrgTeams({ oid: organizationId }), signal));
